import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
import _regeneratorRuntime from '@babel/runtime/regenerator';
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function (sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { getVideo } from './api/transcode';
import MtPlayer from './js/index';
import utils from './core/utils';
import { info } from './js/event-emitter';
var YPlayer = function () {
    function YPlayer(options, callback) {
        _classCallCheck(this, YPlayer);
        this.options = options;
        this.fn = callback;
        this.init();
    }
    _createClass(YPlayer, [
        {
            key: 'init',
            value: function () {
                var _init = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
                    var _this = this;
                    var videoUrl, isJZJX, tranUrl, videoOptions, questionsId, playerOptions;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                            case 0:
                                videoUrl = this.options.video.url;
                                isJZJX = /JZJX_Android/.test(navigator.userAgent);
                                videoUrl = videoUrl.replace(/(7niu|oss)\./, '');
                                this.options.video = Object.assign({}, this.options.video, { url: videoUrl });
                                if (!/((http|https):\/\/|^(\/\/)([\w.]+\/?))\S*/.test(videoUrl)) {
                                    videoUrl = '//'.concat(videoUrl);
                                    this.options.video.url = videoUrl;
                                }
                                tranUrl = null;
                                if (!(!isJZJX && !utils.isM3u8(videoUrl) && utils.isMp4(videoUrl) && (!utils.isMobile || utils.isDingDing || utils.isSSAI))) {
                                    _context.next = 13;
                                    break;
                                }
                                _context.next = 9;
                                return getVideo({
                                    u: this.options.video.url,
                                    sid: this.options.userInfo.school_id
                                });
                            case 9:
                                tranUrl = _context.sent;
                                videoOptions = this.handleVideoOptions(tranUrl);
                                _context.next = 14;
                                break;
                            case 13:
                                videoOptions = this.options.video;
                            case 14:
                                questionsId = this.options.userInfo.question_ids;
                                if (Array.isArray(questionsId)) {
                                    questionsId = questionsId + '';
                                }
                                this.options.collection = {
                                    questionsId: questionsId || 0,
                                    teacherId: sessionStorage.getItem('teacherId') || 0,
                                    sourceType: '101',
                                    sourceUuid: tranUrl && tranUrl.data && tranUrl.data.source_uuid || 0
                                };
                                playerOptions = Object.assign({}, this.options, { video: _objectSpread({}, videoOptions) });
                                this.player = new MtPlayer(playerOptions);
                                this.fn();
                                if (utils.isSSAI) {
                                    window['onHidePage'] = function () {
                                        if (_this.player && !_this.player.paused)
                                            _this.player.pause();
                                    };
                                }
                            case 21:
                            case 'end':
                                return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));
                function init() {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: 'handleVideoOptions',
            value: function handleVideoOptions(tranUrlData) {
                var video = null;
                if (tranUrlData.data.idTranscode) {
                    console.log('命中成功');
                    var routeNum = 0;
                    var trueVideoUrl = (window.location.protocol === 'https:' ? 'https:' : 'http:') + tranUrlData.data.cdn[routeNum] + tranUrlData.data.uri;
                    video = this.handleVideoData(tranUrlData.data, trueVideoUrl, routeNum);
                } else {
                    console.log('未命中');
                    video = this.options.video;
                }
                return video;
            }
        },
        {
            key: 'handleVideoData',
            value: function handleVideoData(tranUrlData, trueVideoUri, routeNum) {
                return {
                    quality: [
                        {
                            name: '标清480P',
                            text: '标清',
                            url: ''.concat(trueVideoUri, '_480.m3u8')
                        },
                        {
                            name: '高清720P',
                            text: '高清',
                            url: ''.concat(trueVideoUri, '_720.m3u8')
                        },
                        {
                            name: '超清1080P',
                            text: '超清',
                            url: ''.concat(trueVideoUri, '_1080.m3u8')
                        }
                    ],
                    defaultQuality: utils.isDingDing || utils.isSSAI ? 0 : 1,
                    uri: tranUrlData.uri,
                    cdn: tranUrlData.cdn,
                    defaultCdn: routeNum,
                    pic: 'https://file1.classba.cn/homepage.png'
                };
            }
        },
        {
            key: 'closeVideo',
            value: function closeVideo() {
                this.player.pause('AT');
                this.player.closeDot();
                this.player.monitor.initCloseWarning();
                if (this.player.pictureInPicture) {
                    this.player.pictureInPicture.hide();
                }
            }
        },
        {
            key: 'skipVideo',
            value: function skipVideo() {
                if (this.player.monitor) {
                    this.player.monitor.initSkipWarning();
                }
                this.player.destroy();
                if (this.player.pictureInPicture) {
                    this.player.pictureInPicture.hide();
                }
            }
        },
        {
            key: 'play',
            value: function play() {
                this.player.play();
            }
        },
        {
            key: 'pause',
            value: function pause(type) {
                this.player.pause(type);
            }
        },
        {
            key: 'on',
            value: function on(name, callback) {
                this.player.on(name, callback);
            }
        },
        {
            key: 'seek',
            value: function seek(time) {
                this.player.seek(time);
            }
        },
        {
            key: 'currentTime',
            value: function currentTime() {
                return this.player.video.currentTime;
            }
        },
        {
            key: 'duration',
            value: function duration() {
                return this.player.video.duration;
            }
        },
        {
            key: 'paused',
            value: function paused() {
                return this.player.video.paused;
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                this.player.destroy();
                if (this.player.monitor && this.player.monitor.dazeTimer) {
                    clearInterval(this.player.monitor.dazeTimer);
                    this.player.monitor.dazeTimeCalc = 0;
                }
            }
        },
        {
            key: 'enableBar',
            value: function enableBar() {
                this.player.controller.initPlayedBar();
                if (this.player.monitor) {
                    this.player.monitor.initSeekWarning();
                }
            }
        },
        {
            key: 'replay',
            value: function replay() {
                if (this.player.template.endPanel) {
                    this.player.template.endPanel.classList.add('dplayer-endpanel-wrap-hide');
                }
                this.player.seek(0);
                this.player.play();
                this.player.events.trigger('replay');
            }
        },
        {
            key: 'fullscreen',
            value: function fullscreen() {
                var isFullScreen = document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement;
                if (this.player.fullScreen) {
                    this.player.fullScreen.toggle('browser');
                } else if (!isFullScreen) {
                    if (this.player.container.requestFullscreen) {
                        this.player.container.requestFullscreen();
                    } else if (this.player.container.mozRequestFullScreen) {
                        this.player.container.mozRequestFullScreen();
                    } else if (this.player.container.webkitRequestFullscreen) {
                        this.player.container.webkitRequestFullscreen();
                    } else if (this.player.video.webkitEnterFullscreen) {
                        this.player.video.webkitEnterFullscreen();
                    } else if (this.player.video.webkitEnterFullScreen) {
                        this.player.video.webkitEnterFullScreen();
                    } else if (this.player.container.msRequestFullscreen) {
                        this.player.container.msRequestFullscreen();
                    }
                } else {
                    if (document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.webkitCancelFullscreen) {
                        document.webkitCancelFullscreen();
                    } else if (document.msCancelFullScreen) {
                        document.msCancelFullScreen();
                    } else if (document.msExitFullscreen) {
                        document.msExitFullscreen();
                    }
                }
            }
        }
    ]);
    return YPlayer;
}();
export default YPlayer;